import React, { useState, useEffect, useRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons'
import './styles.scss';
import {TWO_FACTOR_AUTH} from "../../../lib/constants";

const chat = ({chatData, user, onChatClick, banner_id}) => {
    const chatBodyAndSendBoxHeight = 344;
    const [chatBodyHeight, setChatBodyHeight] = useState(304);              // by default chat body height is 304 pixels

    const calculateChatBodyHeight = (textAreaHeight) => {
        let bodyHeight = chatBodyAndSendBoxHeight - textAreaHeight;
        setChatBodyHeight(bodyHeight);
    }

    const chatBodyStyle = {
        height: chatBodyHeight
    }

    const messagesEndRef = useRef(null)
    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({behavior: "smooth"})
    }

    useEffect(() => {
        scrollToBottom()
    }, [chatData])

    const renderMessages = () => {

        if(!chatData) {
            return;
        }

        const sender = TWO_FACTOR_AUTH ? user.username : user.id;

        const parseColor = rgb => {
            const r = rgb.r;
            const g = rgb.g;
            const b = rgb.b;
            return `rgb(${r}, ${g}, ${b})`
        }

        const convertEpochToHumanDate = epochDate => {
            const date = new Date(epochDate);

            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hours = date.getHours();
            const ampm = hours >= 12 ? 'PM' : 'AM'; 
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();

            const now = Date.now();
            const twelveHoursFromEpochDate = date.getTime() + (12 * 60 * 60 * 1000);
            if (now > twelveHoursFromEpochDate) {
                // more than 12 hours
                return `${month}/${day}/${year} - ${hours}:${minutes}:${seconds} ${ampm}`
            } else {
                return `${hours}:${minutes}:${seconds} ${ampm}`
                // less than 12 hours
            }
        }

        if(!chatData.message || chatData.message.length <= 0) {
            return;
        }

        const reversedMessages = [...chatData.message].reverse();

        return reversedMessages.map((msg, index) => {
            const participant = chatData.participants[msg.sender]
            const mnemonic_style = {
                backgroundColor: parseColor(participant.color)
            }
            const chat__participant_info_style = {
                flexDirection: sender === msg.sender ? 'row-reverse' : 'row'
            }

            return (
                <div className='chat__message' key={index}>
                    <div className='chat__participant_info' style={chat__participant_info_style}>
                        <div className='chat__mnemonic' style={mnemonic_style}>
                            {participant.mnemonic}
                        </div>
                        <div className='chat__participant_name_timestamp'>
                            <div className='chat__name'>
                                {participant.name}
                            </div>
                            <div className='chat__timestamp'>
                                {convertEpochToHumanDate(msg.created_ms)}
                            </div>
                        </div>
                    </div>
                    <div className='chat__message_content'>
                        {msg.message}
                    </div>
                </div>
            )
        })
    }

	return (
        <div className='chat'>
            <div className='chat__header'>
                <div className='chat__title'>
                    {!chatData || !chatData.title ? '' : chatData.title}
                </div>
                <button className='chat__close_button' onClick={() => onChatClick(banner_id)}><FontAwesomeIcon icon={faTimes} color='white' /></button>
            </div>
            <div className='chat__body' style={chatBodyStyle}>
                {/* loop through chat using map */}
                {renderMessages()}
                <div ref={messagesEndRef} />
            </div>
            <div className='chat__send'>
                <TextareaAutosize className='chat__message_to_send' type='text' placeholder='Send a message' minRows={0} maxRows={7} onHeightChange={(height, options) => calculateChatBodyHeight(height, options)} />
                <button className='chat__send_button'><FontAwesomeIcon icon={faPaperPlane} color='#ccc' /></button>
            </div>
        </div>
	);
};

export default chat;
